<div class="bg-white dark:bg-slate-900 overflow-hidden relative" [ngClass]="{
        'fixed inset-0 sm:static max-h-screen sm:max-h-[80vh] max-w-screen min-w-[200px] min-h-[280px] sm:inset-auto flex flex-col sm:rounded-2xl shadow-lg sm:min-w-120 sm:w-120 md:min-w-200 md:w-200': !isDrawer,
        'inset-0 w-full h-full h-screen max-h-screen flex flex-col overflow-hidden': isDrawer
    }">
    <!-- Header: Estética Historial / Save-Insumo -->
    <div class="flex w-full items-center justify-between py-4 px-6 border-b border-gray-100 bg-gray-50/50 shrink-0">
        <div class="flex flex-col">
            <div class="flex items-center gap-2">
                <span class="text-xl font-bold text-gray-800 leading-tight border-l-4 pl-3"
                    [ngClass]="color_primario ? '' : 'border-primary'" [style.border-color]="color_primario || ''">
                    {{ isDetailMode ? 'Detalle del Ticket #' + activeTicket?.idticket : 'Carga de Ticket' }}
                </span>
            </div>
            <div class="flex items-center mt-1 ml-4 opacity-70">
                <span class="text-[10px] font-black uppercase tracking-widest"
                    [ngClass]="color_primario ? '' : 'text-primary'" [style.color]="color_primario || ''">
                    {{ ticketForm.get('modulo')?.value || moduloActual || '' }}
                </span>
                <span class="mx-2 text-gray-300">•</span>
                <span class="text-[10px] font-bold uppercase tracking-widest text-gray-500">
                    {{ ticketForm.get('menu')?.value || menuActual || '' }}
                </span>
                <ng-container *ngIf="isDetailMode && activeTicket?.fecha_carga">
                    <span class="mx-2 text-gray-300">•</span>
                    <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400">
                        {{ activeTicket?.fecha_carga }}
                    </span>
                </ng-container>
            </div>
        </div>
        <button mat-icon-button (click)="cancelar()">
            <mat-icon class="text-gray-400 hover:text-gray-600 transition-colors">close</mat-icon>
        </button>
    </div>

    <!-- Content Area con Scroll -->
    <div #scrollContainer class="w-full flex flex-col gap-3 flex-1 min-h-0 overflow-y-auto px-6 py-4">
        
        <!-- Banner Borrador Recuperado -->
        <div *ngIf="!isDetailMode && tieneBorradorGuardado"
            class="flex items-center justify-between p-3 mb-1 bg-amber-50/80 border border-amber-200/80 rounded-xl text-amber-800 shadow-2xs animate-in fade-in duration-300">
            <div class="flex items-center gap-2">
                <mat-icon class="icon-size-4 text-amber-600 shrink-0" [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
                <span class="text-xs font-semibold">Continuando borrador guardado</span>
            </div>
            <button type="button" mat-button (click)="descartarBorrador()"
                class="!text-xs !font-bold !text-amber-700 hover:!bg-amber-100/80 !h-7 !px-2.5 !rounded-lg transition-colors">
                Descartar borrador
            </button>
        </div>

        <!-- MODO CREACIÓN (FORMULARIO AL ESTILO SAVE-INSUMOS) -->
        <form *ngIf="!isDetailMode" [formGroup]="ticketForm" class="flex flex-col sm:w-full md:w-full">
            
            <!-- SECCIÓN 1: INFORMACIÓN DEL CONTEXTO -->
            <div class="mt-2 mb-4 flex items-center gap-2 border-b border-slate-100 pb-2">
                <mat-icon class="icon-size-5 text-primary" [ngClass]="color_primario ? '' : 'text-primary'" [style.color]="color_primario || ''"
                    [svgIcon]="'heroicons_outline:view-columns'"></mat-icon>
                <span class="text-xs font-bold text-slate-500 uppercase tracking-widest">Información del Contexto</span>
            </div>

            <!-- Fila 1: Módulo (50%) + Menú / Pantalla (50%) -->
            <div class="flex gap-4 mt-2 flex-col sm:flex-row">
                <mat-form-field appearance="fill" class="field-bg-gray w-full sm:w-1/2" [floatLabel]="'always'">
                    <mat-label class="inline-flex items-center gap-1 vertical-align-top">
                        <mat-icon [style.color]="color_primario || ''" class="icon-size-5"
                            [svgIcon]="'heroicons_outline:view-columns'"></mat-icon>
                        Módulo</mat-label>
                    <input type="text" matInput formControlName="modulo" placeholder="Ej: Ventas" />
                    <button mat-icon-button matSuffix type="button" (click)="ticketForm.get('modulo').setValue('')"
                        *ngIf="
                            ticketForm.get('modulo').value &&
                            !ticketForm.get('modulo')?.disabled
                        ">
                        <mat-icon class="text-xl">clear</mat-icon>
                    </button>
                    <mat-error *ngIf="ticketForm.get('modulo')?.hasError('required')">
                        El módulo es obligatorio
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="field-bg-gray w-full sm:w-1/2" [floatLabel]="'always'">
                    <mat-label class="inline-flex items-center gap-1 vertical-align-top">
                        <mat-icon [style.color]="color_primario || ''" class="icon-size-5"
                            [svgIcon]="'heroicons_outline:window'"></mat-icon>
                        Menú / Pantalla</mat-label>
                    <input type="text" matInput formControlName="menu" placeholder="Ej: Alta de Ticket" />
                    <button mat-icon-button matSuffix type="button" (click)="ticketForm.get('menu').setValue('')"
                        *ngIf="
                            ticketForm.get('menu').value &&
                            !ticketForm.get('menu')?.disabled
                        ">
                        <mat-icon class="text-xl">clear</mat-icon>
                    </button>
                    <mat-error *ngIf="ticketForm.get('menu')?.hasError('required')">
                        El menú es obligatorio
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Fila 2: Usuario que reportó (100%) -->
            <div class="flex w-full mt-2">
                <mat-form-field appearance="fill" class="field-bg-gray w-full" [floatLabel]="'always'">
                    <mat-label class="inline-flex items-center gap-1 vertical-align-top">
                        <mat-icon [style.color]="color_primario || ''" class="icon-size-5"
                            [svgIcon]="'heroicons_outline:user'"></mat-icon>
                        Usuario que reportó</mat-label>
                    <input type="text" matInput formControlName="usuario" [readonly]="true" />
                </mat-form-field>
            </div>

            <!-- SECCIÓN 2: DETALLE DEL REPORTE -->
            <div class="mt-6 mb-4 flex items-center gap-2 border-b border-slate-100 pb-2">
                <mat-icon class="icon-size-5 text-primary" [ngClass]="color_primario ? '' : 'text-primary'" [style.color]="color_primario || ''"
                    [svgIcon]="'heroicons_outline:document-text'"></mat-icon>
                <span class="text-xs font-bold text-slate-500 uppercase tracking-widest">Detalle del Reporte</span>
            </div>

            <!-- Fila 1: Título / Descripción Corta (100%) -->
            <div class="flex w-full mt-2">
                <mat-form-field appearance="fill" class="field-bg-gray w-full" [floatLabel]="'always'">
                    <mat-label class="inline-flex items-center gap-1 vertical-align-top">
                        <mat-icon [style.color]="color_primario || ''" class="icon-size-5"
                            [svgIcon]="'heroicons_outline:tag'"></mat-icon>
                        Título / Descripción corta</mat-label>
                    <input type="text" matInput formControlName="descripcion" placeholder="Ej: Error al guardar comprobante" />
                    <button mat-icon-button matSuffix type="button" (click)="ticketForm.get('descripcion').setValue('')"
                        *ngIf="
                            ticketForm.get('descripcion').value &&
                            !ticketForm.get('descripcion')?.disabled
                        ">
                        <mat-icon class="text-xl">clear</mat-icon>
                    </button>
                    <mat-error *ngIf="ticketForm.get('descripcion')?.hasError('required')">
                        La descripción es obligatoria
                    </mat-error>
                    <mat-error *ngIf="ticketForm.get('descripcion')?.hasError('maxlength')">
                        Máximo 255 caracteres
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Fila 2: Detalle Exhaustivo (100%) -->
            <div class="flex w-full mt-2">
                <mat-form-field appearance="fill" class="field-bg-gray w-full" [floatLabel]="'always'">
                    <mat-label class="inline-flex items-center gap-1 vertical-align-top">
                        <mat-icon [style.color]="color_primario || ''" class="icon-size-5"
                            [svgIcon]="'heroicons_outline:document-text'"></mat-icon>
                        Detalle exhaustivo</mat-label>
                    <textarea matInput formControlName="detalle" rows="5" placeholder="Describe el problema paso a paso..."></textarea>
                    <button mat-icon-button matSuffix type="button" (click)="ticketForm.get('detalle').setValue('')"
                        *ngIf="
                            ticketForm.get('detalle').value &&
                            !ticketForm.get('detalle')?.disabled
                        ">
                        <mat-icon class="text-xl">clear</mat-icon>
                    </button>
                    <mat-error *ngIf="ticketForm.get('detalle')?.hasError('required')">
                        El detalle es obligatorio
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Adjuntos (Ilimitados) -->
            <div class="mt-4 bg-gray-50 dark:bg-slate-800/50 p-4 rounded-xl border border-dashed border-gray-200 dark:border-slate-700">
                <app-adjuntos [titulo]="'Capturas de pantalla / Documentos'"
                    [mensajeVacio]="'Adjunta imágenes o documentos relevantes (puedes adjuntar varios)'" [maxArchivos]="99"
                    [extensionesPermitidas]="['.png', '.jpg', '.jpeg', '.pdf', '.docx', '.xlsx']"
                    [permitirPegar]="true" [mostrarPreview]="true" [mostrarListaArchivos]="false"
                    [color_primario]="color_primario" (archivosChange)="onArchivosChange($event)">
                </app-adjuntos>
            </div>
        </form>

        <!-- MODO DETALLE (FICHA TÉCNICA - MANTENIDA COMPLETAMENTE) -->
        <div *ngIf="isDetailMode && activeTicket" class="flex flex-col space-y-8 animate-in fade-in duration-300">
            
            <!-- Título Principal -->
            <div class="flex flex-col gap-1.5">
                <span class="text-[10px] uppercase font-black text-gray-400 tracking-widest px-1">Asunto del Ticket</span>
                <h3 class="text-2xl font-black text-slate-800 leading-tight">
                    {{ activeTicket.descripcion }}
                </h3>
            </div>

            <!-- Rejilla de Metadatos -->
            <div class="grid grid-cols-2 gap-6 bg-slate-50/50 rounded-2xl p-5 border border-slate-100 shadow-sm">
                <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center text-primary" [style.color]="color_primario || ''">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:view-columns'"></mat-icon>
                    </div>
                    <div class="flex flex-col">
                        <span class="text-[9px] uppercase font-bold text-gray-400 leading-none mb-1">Módulo</span>
                        <span class="text-sm font-bold text-slate-700">{{ activeTicket.modulo }}</span>
                    </div>
                </div>
                <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center text-primary" [style.color]="color_primario || ''">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:window'"></mat-icon>
                    </div>
                    <div class="flex flex-col">
                        <span class="text-[9px] uppercase font-bold text-gray-400 leading-none mb-1">Pantalla</span>
                        <span class="text-sm font-bold text-slate-700">{{ activeTicket.menu }}</span>
                    </div>
                </div>
                <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center text-primary" [style.color]="color_primario || ''">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
                    </div>
                    <div class="flex flex-col">
                        <span class="text-[9px] uppercase font-bold text-gray-400 leading-none mb-1">Fecha Carga</span>
                        <span class="text-sm font-bold text-slate-700">{{ activeTicket.fecha_carga }}</span>
                    </div>
                </div>
                <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center text-primary" [style.color]="color_primario || ''">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:user'"></mat-icon>
                    </div>
                    <div class="flex flex-col">
                        <span class="text-[9px] uppercase font-bold text-gray-400 leading-none mb-1">Estado</span>
                        <span class="text-sm font-bold" [style.color]="getEstadoColor(activeTicket.estado)">{{ activeTicket.estado }}</span>
                    </div>
                </div>
            </div>

            <!-- Descripción Detallada -->
            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-2 px-1">
                    <mat-icon class="icon-size-4 text-gray-400" [svgIcon]="'heroicons_outline:document-text'"></mat-icon>
                    <span class="text-[10px] uppercase font-black text-gray-500 tracking-widest">Detalle del Reporte</span>
                </div>
                <div class="bg-white rounded-2xl p-6 border border-slate-200 relative overflow-hidden">
                    <div class="absolute top-0 left-0 w-1 h-full" [style.background-color]="color_primario || ''"></div>
                    <p class="text-slate-600 text-sm leading-relaxed whitespace-pre-wrap font-medium italic">
                        "{{ activeTicket.detalle }}"
                    </p>
                </div>
            </div>

            <!-- Sección de Archivos Adjuntos (Modo Detalle) -->
            <div *ngIf="adjuntosDetalle && adjuntosDetalle.length > 0" class="flex flex-col gap-3">
                <div class="flex items-center justify-between px-1">
                    <div class="flex items-center gap-2">
                        <mat-icon class="icon-size-4 text-gray-400" [svgIcon]="'heroicons_outline:paper-clip'"></mat-icon>
                        <span class="text-[10px] uppercase font-black text-gray-500 tracking-widest">Archivos Adjuntos</span>
                    </div>
                    <span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">
                        {{ adjuntosDetalle.length }} {{ adjuntosDetalle.length === 1 ? 'archivo' : 'archivos' }}
                    </span>
                </div>

                <!-- Lista de adjuntos en ancho completo -->
                <div class="flex flex-col gap-4">
                    <ng-container *ngFor="let adj of adjuntosDetalle">
                        <!-- Si es imagen: Únicamente la imagen a ancho completo -->
                        <div *ngIf="esImagenAdjunto(adj.extension)" class="w-full">
                            <a [href]="obtenerUrlAdjuntoSegura(adj.url)" target="_blank" rel="noopener noreferrer" 
                               class="block w-full cursor-zoom-in"
                               matTooltip="Clic para ver en tamaño completo">
                                <img [src]="obtenerUrlAdjuntoSegura(adj.url)" 
                                     alt="Adjunto" 
                                     class="w-full h-auto rounded-xl block">
                            </a>
                        </div>

                        <!-- Si no es imagen (ej: PDF, docs) -->
                        <div *ngIf="!esImagenAdjunto(adj.extension)" 
                             class="w-full bg-slate-50 rounded-xl border border-slate-200 p-4 flex items-center justify-between gap-3">
                            <div class="flex items-center gap-3">
                                <div class="w-10 h-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center text-slate-500">
                                    <mat-icon [svgIcon]="obtenerIconoAdjunto(adj.extension)" class="icon-size-5"></mat-icon>
                                </div>
                                <div class="flex flex-col">
                                    <span class="text-xs font-semibold text-slate-700">{{ adj.nombre }}</span>
                                    <span class="text-[10px] text-slate-400 uppercase font-medium">Documento {{ adj.extension }}</span>
                                </div>
                            </div>
                            <a [href]="obtenerUrlAdjuntoSegura(adj.url)" target="_blank" rel="noopener noreferrer"
                               mat-stroked-button class="!rounded-xl !text-slate-700 !border-slate-300 text-xs">
                                <mat-icon class="icon-size-4 mr-1">open_in_new</mat-icon>
                                Ver archivo
                            </a>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- Sección de Resolución (Si existe detalle_resolucion) -->
            <div *ngIf="activeTicket.detalle_resolucion" 
                class="flex flex-col gap-3 animate-in slide-in-from-bottom-4 duration-500 delay-150">
                <div class="flex items-center gap-2 px-1 text-green-600">
                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
                    <span class="text-[10px] uppercase font-black tracking-widest">Resolución Técnica</span>
                </div>
                <div class="bg-green-50/50 rounded-2xl p-6 border border-green-200 relative">
                    <div class="flex flex-col gap-4">
                        <div class="flex items-center justify-between">
                            <span class="text-[10px] font-bold text-green-700/60 leading-none uppercase">Solución Aportada</span>
                            <span *ngIf="activeTicket.fecha_resolucion" class="text-[10px] font-bold text-green-700/60 leading-none">{{ activeTicket.fecha_resolucion }}</span>
                        </div>
                        <p class="text-green-900 text-sm font-bold leading-relaxed">
                            {{ activeTicket.detalle_resolucion }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Sección de Publicación / Deploy -->
            <div *ngIf="activeTicket.deployado == 1 && activeTicket.fecha_deploy && activeTicket.fecha_deploy !== '-'" 
                class="flex flex-col gap-3 animate-in slide-in-from-bottom-4 duration-500 delay-200">
                <div class="flex items-center gap-2 px-1 text-purple-600">
                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:clipboard-document-check'"></mat-icon>
                    <span class="text-[10px] uppercase font-black tracking-widest">Publicación en Producción</span>
                </div>
                <div class="bg-purple-50/50 rounded-2xl p-6 border border-purple-200 relative">
                    <div class="flex flex-col gap-4">
                        <div class="flex items-center justify-between">
                            <span class="text-[10px] font-bold text-purple-700/60 leading-none uppercase">Estado de Publicación</span>
                            <span *ngIf="activeTicket.fecha_deploy" class="text-[10px] font-bold text-purple-700/60 leading-none">{{ activeTicket.fecha_deploy }}</span>
                        </div>
                        <p class="text-purple-900 text-sm font-bold leading-relaxed">
                            El ticket ha sido publicado con éxito en producción y se encuentra disponible para su verificación.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer: Botones con Adaptación (En Drawer siempre en fila dividida al ras como en Jedstion) -->
    <div class="w-full border-t border-gray-200 bg-gray-50 flex items-stretch divide-x divide-gray-200 shrink-0"
        [ngClass]="{
            'flex-row p-0': isDrawer,
            'flex-col p-3 sm:p-0 gap-2.5 sm:gap-0 sm:flex-row': !isDrawer
        }">
        <!-- Botón Cancelar (Izquierda, 50% de ancho, al ras) -->
        <button mat-stroked-button
            class="flex-1 py-3 sm:py-4 !text-slate-700 !bg-transparent hover:!bg-slate-100 active:!bg-slate-200 transition-colors flex items-center justify-center gap-2 !rounded-none !border-0 shadow-none"
            (click)="cancelar()" [disabled]="loading">
            <mat-icon class="icon-size-5 !text-slate-500">{{ isDetailMode ? 'close' : 'arrow_back' }}</mat-icon>
            <span class="font-bold">{{ isDetailMode ? 'Cerrar Detalle' : 'Cancelar' }}</span>
        </button>
        
        <!-- Botón Enviar Ticket (Derecha, 50% de ancho, al ras) -->
        <button *ngIf="!isDetailMode" mat-flat-button [style.background-color]="color_primario || ''"
            [style.color]="getContrastColor(color_primario)"
            [ngClass]="color_primario ? '' : 'bg-primary text-white'"
            class="flex-1 py-3 sm:py-4 font-bold transition-all !rounded-none shadow-none" [disabled]="loading"
            (click)="enviar()">
            <div class="flex items-center justify-center gap-2">
                <span *ngIf="!loading">Enviar Ticket</span>
                <mat-icon *ngIf="loading" class="animate-spin" [style.color]="getContrastColor(color_primario)">heroicons_mini:arrow-path</mat-icon>
                <mat-icon *ngIf="!loading" class="icon-size-5" [style.color]="getContrastColor(color_primario)">send</mat-icon>
            </div>
        </button>
    </div>
</div>